import type { CoreState } from '../../types'
import { findActiveBrand } from '../common/findActiveBrand'

export const getActivePriceRange = (state: CoreState): number | undefined => {
  return findActiveBrand(state)?.priceRange
}
